import {
  GET_ENTERPRISE_PRODUCT,
  GET_ENTERPRISE_PRODUCT_SUCCESS,
  GET_ENTERPRISE_PRODUCT_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getEnterpriseProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ENTERPRISE_PRODUCT:
      return { ...state, loading: true };
    case GET_ENTERPRISE_PRODUCT_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_ENTERPRISE_PRODUCT_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getEnterpriseProductReducer;
